import React from 'react';
import './style.scss';
import {Coins} from '../Coins';

export const FriendCard = ({image, title, coins, onClick}) => {
  return <div className="app-friend-card">
    <img src={image} alt="" className="app-friend-card--image"/>
    <div className="app-friend-card--content">
      <div className="app-friend-card--title" data-title={title}/>
      <Coins coins={coins} big={false}/>
    </div>
  </div>;
}